import { Grid, Select } from '@mui/material'
import { WaitAndReturn } from 'api/vehicle/taxisAPI.types'
import Input from 'components/RouteWizard/Input'
import React from 'react'
import { Control, FieldValues } from 'react-hook-form'

interface WaitAndReturnProps {
  control: Control<FieldValues> | any | undefined
  waitAndReturn: WaitAndReturn
  isEdit?: boolean
  onChange?: (value: boolean) => void
}

const WaitAndReturnClient: React.FC<WaitAndReturnProps> = ({
  control,
  waitAndReturn,
  isEdit,
  onChange,
}) => {
  const [waitAndReturnType, setWaitAndReturnType] = React.useState<string>(
    waitAndReturn?.chargingPeriod.period ? 'yes' : 'no',
  )
  console.log('PickupAndWait waitingPeriodType: ', waitAndReturnType)
  console.log('PickupAndWait waitingTime: ', waitAndReturn)

  React.useEffect(() => {
    onChange?.(waitAndReturnType === 'yes' ? true : false)
  }, [waitAndReturnType, setWaitAndReturnType])

  return (
    <Grid container spacing={2}>
      <Grid item xs={3}>
        <Select
          disabled={!isEdit}
          onChange={(event) => {
            const selectedValue = event.target.value as string
            if (control && control.reset) {
              control.reset({
                'waitAndReturn.freePeriod': '',
                'waitAndReturn.gracePeriod.period': '',
                'waitAndReturn.chargingPeriod.period': '',
              })
            }
            setWaitAndReturnType(selectedValue)
          }}
          fullWidth
          value={waitAndReturnType}
          native
          inputProps={{
            name: 'waitingTimeType',
          }}
        >
          <option value="yes">Yes</option>
          <option value="no">No</option>
        </Select>

        {/* //   name="waitingTimeType"
        //   options={WaitingPeriod}
        //   label={'Waiting Time Type'}
        //   topRow={{ value: '', label: 'Select Waiting Type' }}
        //   sx={{ width: '100%' }}
        //   {...{ readOnly: isEdit }}
        //   onChange={(value: string) => setWaitingPeriodType(value)}
        /> */}
      </Grid>
      {waitAndReturnType === 'yes' && (
        <>
          <Grid item xs={4}>
            <Input
              name="waitAndReturn.discount"
              control={control}
              label="Discount"
              fullWidth
              type="number"
              InputProps={{
                endAdornment: <span>%</span>,
              }}
              disabled={!isEdit}
            />
          </Grid>
          <Grid item xs={3}>
            <Input
              name="waitAndReturn.chargingPeriod.period"
              control={control}
              label="Additional Waiting Units"
              fullWidth
              type="number"
              InputProps={{
                endAdornment: <span>minutes</span>,
              }}
              disabled={!isEdit}
            />
          </Grid>
        </>
      )}
    </Grid>
  )
}

export default WaitAndReturnClient
